import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation, Navigate } from 'react-router-dom';
import {
  LayoutDashboard, Briefcase, Building2, Package, ShoppingCart,
  Warehouse, Settings, ChevronLeft, ChevronRight,
  LogOut, Zap
} from 'lucide-react';
import './App.css';

import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Fournisseurs from './pages/Fournisseurs';
import FournisseurDetail from './pages/FournisseurDetail';
import Equipements from './pages/Equipements';
import EquipementDetail from './pages/EquipementDetail';
import Commandes from './pages/Commandes';
import CommandeDetail from './pages/CommandeDetail';
import Stocks from './pages/Stocks';
import Parametres from './pages/Parametres';

import { utilisateurConnecte, entreprise } from './data/mockData';

const Navigation = ({ isCollapsed, setIsCollapsed }) => {
  const location = useLocation();

  const navItems = [
    { section: 'Pilotage' },
    { path: '/', icon: LayoutDashboard, label: 'Tableau de bord' },
    { section: 'ERP Stock & Tracabilite' },
    { path: '/clients', icon: Briefcase, label: 'Clients (Marches)' },
    { path: '/fournisseurs', icon: Building2, label: 'Fournisseurs' },
    { path: '/equipements', icon: Package, label: 'Equipements' },
    { path: '/commandes', icon: ShoppingCart, label: 'Commandes' },
    { path: '/stocks', icon: Warehouse, label: 'Stocks & Entrepots' },
  ];

  return (
    <nav className={`navigation ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="nav-header">
        <div className="nav-brand">
          <div className="brand-icon-wrapper">
            <Zap size={20} />
          </div>
          {!isCollapsed && (
            <div>
              <h1>{entreprise.nom}</h1>
              <p>{entreprise.slogan}</p>
            </div>
          )}
        </div>
        <button className="nav-toggle" onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>

      {!isCollapsed && (
        <div className="nav-user">
          <div className="user-avatar">
            {utilisateurConnecte.prenom[0]}{utilisateurConnecte.nom[0]}
          </div>
          <div className="user-info">
            <p className="user-name">{utilisateurConnecte.prenom} {utilisateurConnecte.nom}</p>
            <p className="user-role">{utilisateurConnecte.role}</p>
          </div>
        </div>
      )}

      <ul className="nav-menu">
        {navItems.map((item, index) => {
          if (item.section) {
            return !isCollapsed && (
              <li key={`s-${index}`} className="nav-section">{item.section}</li>
            );
          }
          const Icon = item.icon;
          const isActive = item.path === '/'
            ? location.pathname === '/'
            : location.pathname.startsWith(item.path);
          return (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={`nav-link ${isActive ? 'active' : ''}`}
                title={isCollapsed ? item.label : ''}
              >
                <Icon size={18} />
                {!isCollapsed && <span>{item.label}</span>}
              </NavLink>
            </li>
          );
        })}
      </ul>

      <div className="nav-footer">
        <button className="nav-logout" title="Deconnexion">
          <LogOut size={16} />
          {!isCollapsed && <span>Deconnexion</span>}
        </button>
      </div>
    </nav>
  );
};

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <Router>
      <div className="app">
        <Navigation
          isCollapsed={sidebarCollapsed}
          setIsCollapsed={setSidebarCollapsed}
        />
        <main className={`main-content ${sidebarCollapsed ? 'sidebar-closed' : ''}`}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/fournisseurs" element={<Fournisseurs />} />
            <Route path="/fournisseurs/:id" element={<FournisseurDetail />} />
            <Route path="/equipements" element={<Equipements />} />
            <Route path="/equipements/:id" element={<EquipementDetail />} />
            <Route path="/commandes" element={<Commandes />} />
            <Route path="/commandes/:id" element={<CommandeDetail />} />
            <Route path="/stocks" element={<Stocks />} />
            <Route path="/parametres" element={<Parametres />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
